import classNames from 'classnames';
import { getBackgroundProp, resolveSetting } from '../../../utils/settingsHelper';
import { toSafeFontName } from '../../../utils/fonts';
import { roundedOptions, shadowOptions } from '../../editor/Toolbar/options';

export const getLinkStyle = (props, settings, isActive = false) => {
	const { color, activeColor, activeBottomBorder, padding, borderWidth, borderColor, clipPath, fontFamily } = props;

	const resolvedColor = isActive && activeColor ? resolveSetting(activeColor, settings) : resolveSetting(color, settings);

	return {
		background: getBackgroundProp(props, settings),
		color: resolvedColor,
		borderWidth: `${resolveSetting(borderWidth, settings)}px`,
		borderColor: resolveSetting(borderColor, settings),
		...(isActive && activeBottomBorder ? {
			borderBottomWidth: '2px',
			borderBottomStyle: 'solid',
			borderBottomColor: resolvedColor,
		} : {}),
		// margin: margin ? `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px` : undefined,
		paddingTop: padding ? `${resolveSetting(padding[0], settings)}px` : '',
		paddingRight: padding ? `${resolveSetting(padding[1], settings)}px` : '',
		paddingBottom: padding ? `${resolveSetting(padding[2], settings)}px` : '',
		paddingLeft: padding ? `${resolveSetting(padding[3], settings)}px` : '',
		clipPath: clipPath ? clipPath.trim().replace(/;+$/, '') : undefined,
		fontFamily: toSafeFontName(resolveSetting(fontFamily, settings)) || undefined,
	};
};

export const getLinkClasses = (props, settings) => classNames(
	{ [roundedOptions[resolveSetting(props.rounded, settings)]]: !!resolveSetting(props.rounded, settings) },
	{ [shadowOptions[resolveSetting(props.shadow, settings)]]: !!resolveSetting(props.shadow, settings) },
);
